<template>
  <div>
    <v-col col="12">
      <v-card outlined>
        <v-card-title>
          Space Filters
        </v-card-title>
        <v-card-text>
          <v-row py-6>
            <v-select :items="value.groupSpaceType" v-model="value.groupSpaceTypeValue" label="Space Type"
                      outlined multiple chips deletable-chips persistent-hint hint="Empty List Is All Space Types"></v-select>
          </v-row>
          <v-row py-6>
            <v-select :items="value.groupSpaceGroup" v-model="value.groupSpaceGroupValue" label="Space Department"
                      outlined multiple chips deletable-chips persistent-hint hint="Empty List Is All Space Departments"></v-select>
          </v-row>
          <v-row py-6>
            <v-select :items="value.groupSpaceAccess" v-model="value.groupSpaceAccessValue" label="Space Position"
                      outlined multiple chips deletable-chips persistent-hint
                      hint="Empty List Is All Space Position Types"></v-select>
          </v-row>
          <v-row py-6>
            <v-select :items="value.groupFloorNumber" v-model="value.groupFloorNumberValue" label="Floors"
                      outlined multiple chips deletable-chips persistent-hint
                      hint="Empty List Is All Floors"></v-select>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'InsightReportSpaceFilters',
  props: ['value'],
  components: {},
  computed: mapState({}),
  data: () => {
    return {}
  }
}
</script>

<style scoped>

</style>
